/* Wool Journal accessory add-ons (Elastic Band / Pen Loop) — Books Beyond Borders */
(function () {
  'use strict';

  var root = document.getElementById('wool-journal-addons');
  if (!root) return;

  var pendingItems = null;

  /* ----------------------------------------------------------------------
   * Cart add-on logic
   * ------------------------------------------------------------------- */

  function getSelectedAddonItems() {
    var items = [];
    var productTitle = root.getAttribute('data-product-title');

    root.querySelectorAll('[data-addon]').forEach(function (addonEl) {
      var toggle = addonEl.querySelector('.checkbox-control input');
      if (!toggle || !toggle.checked) return;

      var checkedSwatch = addonEl.querySelector('input[type="radio"]:checked');
      var variantId = checkedSwatch
        ? checkedSwatch.closest('[data-variant-id]').getAttribute('data-variant-id')
        : addonEl.getAttribute('data-variant-id');

      if (variantId) {
        var item = { id: parseInt(variantId, 10), quantity: 1 };
        // Tags which journal this accessory belongs to, since it's added as
        // its own separate cart line rather than a variant of the journal
        // itself — without this, two different designs bought together with
        // matching accessory colours merge into one anonymous cart/order
        // line ("Pen Loop x2, Black") with no way for whoever's packing the
        // order to tell which journal each one ships with.
        if (productTitle) {
          item.properties = { 'For': productTitle };
        }
        items.push(item);
      }
    });
    return items;
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['cart-drawer']) return;
        var f = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer');
        if (f) drawer.innerHTML = f.innerHTML;
      });
  }

  function hookAfterCartAdd() {
    var origFetch = window.fetch;
    window.fetch = function (url, opts) {
      var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
      var isCartAdd = urlStr.indexOf('/cart/add.js') !== -1;
      var promise = origFetch.apply(this, arguments);

      if (isCartAdd && pendingItems && pendingItems.length) {
        var items = pendingItems;
        pendingItems = null;

        promise.then(function (response) {
          if (!response.ok) return;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () {
            return refreshCartDrawer();
          }).catch(function (err) {
            console.error('BBB wool-journal-addons: addon add failed', err);
          });
        }).catch(function () {});
      }

      return promise;
    };
  }

  function hookCart() {
    document.addEventListener('click', function (e) {
      var items = getSelectedAddonItems();
      if (!items.length) return;

      var btn = e.target.closest('button[type="submit"], [type="submit"]');
      if (!btn || btn.closest('cart-drawer')) return;

      var form = btn.closest('form[action*="/cart/add"], product-form');
      if (!form) return;

      pendingItems = items;
    }, false);
  }

  /* ----------------------------------------------------------------------
   * Live colour preview overlaid on the main product photo
   *
   * Both the band and the loop are detected pixel-by-pixel from whichever
   * photo is actually displayed, rather than positioned with a fixed shape,
   * because neither one is a clean axis-aligned rectangle in the photo: the
   * band is long and slightly slanted, and the loop is a small, irregularly
   * edged fold of fabric sitting right next to a dark shadow cast by the
   * spine — a flat rectangle over either one either clips the real edges or
   * bleeds colour onto the surrounding photo, which reads as a pasted
   * sticker rather than a recoloured part of the image.
   *
   * The photo actually classified for colour is NOT necessarily the photo
   * shown on screen: main product photos are meant to be "bare" (no physical
   * band/loop attached), so with both add-ons off the customer sees a plain
   * journal, but there's then nothing to sample real fabric pixels from. If
   * the product has a hidden reference photo (alt text "wj-reference",
   * excluded from the visible gallery by product-gallery.liquid — see
   * data-reference-image on the root element below) that photo is loaded for
   * classification instead, while the resulting recoloured PNG is still
   * painted onto whichever photo is actually on screen. Products without a
   * reference photo fall back to classifying the on-screen photo directly,
   * same as before.
   *
   * Each target has its own search region (a generous box we know contains
   * the accessory and little else) and its own classifier (a colour test
   * distinguishing the accessory's pixels from whatever else is nearby in
   * that box). The loop picks between two possible looks per photo, because
   * the product photos are mid-rollout to a new prop colour: newer shoots
   * (e.g. Girl with Cat, reshot 2026-07-30) use a neon/lime green tab,
   * chosen specifically for how much more reliably it segments from the
   * shot than the original neutral grey felt — green clearly outpacing both
   * red and blue is a much bigger, more stable gap than "channels are close
   * together," which a shadow (or, on this line, the journal cover's own
   * grey wool) can also satisfy. Older shoots (Sunny/Fuji/Galaxy Cat, not
   * yet reshot) still use the original neutral grey tab. Running both
   * tests as an OR briefly bled colour across the Girl with Cat cover,
   * since its heather-grey wool also passes the grey test — so instead
   * resolveLoopClassifier() picks exactly one test per photo (green if a
   * real tab's worth of green pixels is present, grey otherwise) before
   * building the mask, rather than unioning both.
   * ------------------------------------------------------------------- */

  var REGIONS = {
    // Wide enough to cover the elastic band's real position across the
    // whole A5 Wool Journal line's shared photo template, tight enough to
    // avoid the cover illustration.
    band: { xMin: 0.64, xMax: 0.78, yMin: 0.18, yMax: 0.84 },
    // Tight box around the pen loop tab — the small felt nub that
    // protrudes past the cover's right edge (cover edge sits ~0.80 across).
    // Measured from the live Girl-with-Cat photo: tab spans x 0.795-0.845,
    // y 0.40-0.468. A wider box let the classifier spill onto the whole
    // cover and render as an oversized block clipped to the box.
    loop: { xMin: 0.795, xMax: 0.852, yMin: 0.400, yMax: 0.468 }
  };

  function isBandPixel(r, g, b) {
    // The elastic band photographs as a saturated pink where blue clearly
    // exceeds green (b - g > 10) — this is what separates true pink from
    // tan/brown illustration tones (e.g. the bear's fur), which have the
    // opposite relationship (green > blue) despite superficially similar
    // brightness/redness.
    //
    // The g > 90 && b > 90 floor rejects near-pure-red pixels (high red,
    // near-zero green/blue) that otherwise slip through: on the Fuji Cat
    // photo the red sun sits inside the band's search region and its
    // brightest edge pixels have just enough blue over green to pass the
    // b - g test, which bled the band colour onto the sun. Real pink band
    // fabric always has substantial green AND blue (~180/205), so this
    // floor keeps the band and drops the sun. Verified to leave the Girl,
    // Sunny and Galaxy photos' matches byte-identical.
    return r > 170 && (r - g) > 15 && (b - g) > 10 && g > 90 && b > 90;
  }

  // Neon/lime green tab (newer reference photos). Measured against the
  // Girl with Cat photo (reshot 2026-07-30, avg RGB ~170/224/14): this test
  // catches 97% of the tab's true pixels with zero false positives from the
  // surrounding shadow/background inside the loop region box above.
  function isGreenLoopTab(r, g, b) {
    return (g - r) > 25 && (g - b) > 35 && g > 90;
  }

  // Neutral grey tab (older reference photos, e.g. Sunny/Fuji/Galaxy Cat,
  // not yet reshot with the new prop) — max and min channel close together,
  // in a mid brightness band. This alone is NOT enough to separate the tab
  // from its surroundings on every photo: on Girl with Cat the journal
  // cover itself is a heather-grey wool that also falls in this band, so
  // applying this test unconditionally bled colour across most of the
  // cover. resolveLoopMode() below picks this test only when there's no
  // green tab to find instead, rather than running both at once.
  function isGreyLoopTab(r, g, b) {
    var maxc = Math.max(r, g, b), minc = Math.min(r, g, b);
    var brightness = (r + g + b) / 3;
    return (maxc - minc) < 24 && brightness > 80 && brightness < 215;
  }

  // Decides which loop classifier applies to a given photo by sampling the
  // whole region once for green-tab pixels first. A real green tab covers a
  // large, unmistakable share of the box (~40%+ in practice) — nowhere near
  // what stray green noise could produce — so a low bar (2%) cleanly tells
  // "this photo has the new green prop" apart from "it doesn't," without
  // needing a per-product lookup that would go stale the moment a photo is
  // reshot.
  function resolveLoopClassifier(regionData, pixelCount) {
    var greenCount = 0;
    for (var i = 0; i < pixelCount; i++) {
      var si = i * 4;
      if (isGreenLoopTab(regionData[si], regionData[si + 1], regionData[si + 2])) {
        greenCount++;
        if (greenCount > pixelCount * 0.02) return isGreenLoopTab;
      }
    }
    return isGreyLoopTab;
  }

  var CLASSIFIERS = { band: isBandPixel };

  // How much of each pixel's own shading variation carries through. The
  // band is flat fabric, so its natural highlight/shadow reads nicely once
  // hue-shifted. This is the ONLY texture channel available — the overlay
  // itself is always fully opaque (see the CSS comment in
  // wool-journal-addons.liquid for why: fading it with CSS opacity would
  // blend in the ORIGINAL photo's hue, not just its shading, corrupting
  // the selected colour on photos where that original hue is far from the
  // target, like the neon-green pen loop). Raised from 0.35 after the new
  // photo showed a fuller, more even weave than the old grey tab's patchier
  // fold — real per-pixel lightness variation measured at std 0.063 over
  // L 0.222-0.778, so 0.6 brings out a visibly varied highlight/shadow
  // without the blown-out extremes a damping near 1.0 would give.
  var DAMPING = { band: 0.7, loop: 0.6 };

  // Closes small gaps left by anti-aliased/blended edge pixels — without
  // this, those pixels stay transparent and let the original photo colour
  // show through underneath, which is especially visible with darker
  // swatches. The loop tab is small, so 1 pass is enough; 2 over-grew the
  // mask past the tab's real edge.
  var DILATE_PASSES = { band: 2, loop: 1 };

  function dilateMask(mask, w, h, passes) {
    var current = mask;
    for (var p = 0; p < passes; p++) {
      var next = new Uint8Array(current.length);
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var idx = y * w + x;
          if (current[idx]) { next[idx] = 1; continue; }
          if (
            (x > 0 && current[idx - 1]) ||
            (x < w - 1 && current[idx + 1]) ||
            (y > 0 && current[idx - w]) ||
            (y < h - 1 && current[idx + w])
          ) {
            next[idx] = 1;
          }
        }
      }
      current = next;
    }
    return current;
  }

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max === min) {
      h = s = 0;
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        default: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }
    return [h, s, l];
  }

  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  function hslToRgb(h, s, l) {
    var r, g, b;
    if (s === 0) {
      r = g = b = l;
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  }

  function hexToRgb(hex) {
    var m = hex.replace('#', '');
    return [parseInt(m.substr(0, 2), 16), parseInt(m.substr(2, 2), 16), parseInt(m.substr(4, 2), 16)];
  }

  /* Prepares a target's source pixels, a classified alpha mask, and the
     baseline average lightness of its true pixels — everything
     renderColoredOverlayDataUrl needs to recolour cheaply on every swatch
     change without re-scanning the whole photo again. */
  function prepareRegionData(img, target) {
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return null;

    var srcCanvas = document.createElement('canvas');
    srcCanvas.width = w;
    srcCanvas.height = h;
    var srcCtx = srcCanvas.getContext('2d');
    srcCtx.drawImage(img, 0, 0, w, h);

    var region = REGIONS[target];
    var xStart = Math.max(0, Math.floor(w * region.xMin));
    var xEnd = Math.min(w, Math.ceil(w * region.xMax));
    var yStart = Math.max(0, Math.floor(h * region.yMin));
    var yEnd = Math.min(h, Math.ceil(h * region.yMax));
    var regionW = xEnd - xStart, regionH = yEnd - yStart;

    var regionData = srcCtx.getImageData(xStart, yStart, regionW, regionH).data;
    var alphaMask = new Uint8Array(regionW * regionH);

    var classify = target === 'loop'
      ? resolveLoopClassifier(regionData, regionW * regionH)
      : CLASSIFIERS[target];

    var sumL = 0, count = 0;
    for (var i = 0; i < regionW * regionH; i++) {
      var si = i * 4;
      var r = regionData[si], g = regionData[si + 1], b = regionData[si + 2];
      if (classify(r, g, b)) {
        alphaMask[i] = 1;
        sumL += rgbToHsl(r, g, b)[2];
        count++;
      }
    }

    // Compute the baseline lightness from the strictly-classified pixels
    // (before dilation, so a couple of extra edge pixels don't skew it),
    // then grow the mask itself to close anti-aliased gaps at the edges.
    alphaMask = dilateMask(alphaMask, regionW, regionH, DILATE_PASSES[target]);

    return {
      target: target,
      fullW: w,
      fullH: h,
      xStart: xStart,
      yStart: yStart,
      regionW: regionW,
      regionH: regionH,
      regionData: regionData,
      alphaMask: alphaMask,
      baselineL: count ? sumL / count : 0.5
    };
  }

  function renderColoredOverlayDataUrl(info, hex) {
    var damping = DAMPING[info.target];
    var targetRgb = hexToRgb(hex);
    var targetHsl = rgbToHsl(targetRgb[0], targetRgb[1], targetRgb[2]);
    var targetH = targetHsl[0], targetS = targetHsl[1], targetL = targetHsl[2];

    var outCanvas = document.createElement('canvas');
    outCanvas.width = info.fullW;
    outCanvas.height = info.fullH;
    var outCtx = outCanvas.getContext('2d');
    var outData = outCtx.createImageData(info.fullW, info.fullH);
    var od = outData.data;

    for (var ry = 0; ry < info.regionH; ry++) {
      for (var rx = 0; rx < info.regionW; rx++) {
        var ri = ry * info.regionW + rx;
        if (!info.alphaMask[ri]) continue;

        var si = ri * 4;
        var r = info.regionData[si], g = info.regionData[si + 1], b = info.regionData[si + 2];
        var origL = rgbToHsl(r, g, b)[2];

        var newL = targetL + (origL - info.baselineL) * damping;
        newL = Math.max(0, Math.min(1, newL));

        var newRgb = hslToRgb(targetH, targetS, newL);
        var fx = info.xStart + rx, fy = info.yStart + ry;
        var di = (fy * info.fullW + fx) * 4;
        od[di] = newRgb[0]; od[di + 1] = newRgb[1]; od[di + 2] = newRgb[2]; od[di + 3] = 255;
      }
    }

    outCtx.putImageData(outData, 0, 0);
    return outCanvas.toDataURL('image/png');
  }

  var overlays = {};
  var regionInfo = {};
  var pendingColor = {};
  var preparing = {};

  function getMainImage() {
    // Prefer whichever slide is actually rendered on screen over trusting the
    // ".is-initial" marker blindly: that class reflects Shopify's own
    // product.featured_media / variant.featured_media, which can point at a
    // slide product-gallery.liquid has separately hidden (e.g. the
    // wj-reference photo, if it's ever misconfigured as the featured image)
    // — .is-initial and [hidden] would then both land on the SAME element,
    // and attaching the overlay to that hidden slide's zero-size box makes
    // the colour render but stay invisible, with no error anywhere to catch.
    var candidates = document.querySelectorAll('.product-gallery__media img');
    for (var i = 0; i < candidates.length; i++) {
      var img = candidates[i];
      var media = img.closest('.product-gallery__media');
      if (media && !media.hasAttribute('hidden') && media.offsetParent !== null) {
        return img;
      }
    }
    return document.querySelector('.product-gallery__media img');
  }

  function loadImageForCanvas(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function ensureParentPositioned(img) {
    var parent = img.parentElement;
    var parentPosition = getComputedStyle(parent).position;
    if (parentPosition === 'static') {
      parent.style.position = 'relative';
    }
    return parent;
  }

  function ensureOverlay(target) {
    if (overlays[target]) return overlays[target];

    var img = getMainImage();
    if (!img) return null;
    var parent = ensureParentPositioned(img);

    var el = document.createElement('div');
    el.className = 'wj-overlay';
    parent.appendChild(el);
    overlays[target] = el;

    if (!preparing[target]) {
      preparing[target] = true;
      // Classify colour from the hidden reference photo (still shows the
      // physical sample band/loop) when the product has one, since the
      // photo actually on screen is meant to be the bare shot with nothing
      // to sample. Falls back to the on-screen photo for products with no
      // reference image set up.
      var referenceImageUrl = root.getAttribute('data-reference-image');
      var srcUrl = referenceImageUrl || img.currentSrc || img.src;
      loadImageForCanvas(srcUrl).then(function (loadedImg) {
        regionInfo[target] = prepareRegionData(loadedImg, target);
        if (pendingColor[target]) {
          applyColor(target, pendingColor[target]);
        }
      }).catch(function (err) {
        console.error('BBB wool-journal-addons: could not prepare ' + target + ' region', err);
      });
    }

    return el;
  }

  function applyColor(target, hex) {
    var el = overlays[target];
    if (!el) return;
    var info = regionInfo[target];
    if (!info) return;
    var dataUrl = renderColoredOverlayDataUrl(info, hex);
    el.style.backgroundImage = 'url(' + dataUrl + ')';
    if (lightboxOverlays[target]) {
      lightboxOverlays[target].style.backgroundImage = el.style.backgroundImage;
    }
  }

  function setOverlayColor(target, hex) {
    var el = ensureOverlay(target);
    if (!el || !hex) return;
    pendingColor[target] = hex;
    if (regionInfo[target]) {
      applyColor(target, hex);
    }
  }

  function showOverlay(target, show) {
    var el = overlays[target];
    if (!el) return;
    el.classList.toggle('wj-overlay--visible', !!show);
    if (lightboxOverlays[target]) {
      lightboxOverlays[target].classList.toggle('wj-overlay--visible', !!show);
    }
  }

  /* ----------------------------------------------------------------------
   * Zoom / lightbox support
   *
   * The zoom button opens a PhotoSwipe lightbox, which is a brand new DOM
   * tree appended straight to <body> (see .pswp__zoom-wrap > .pswp__img) —
   * it is not the same <img> element the gallery overlays are attached to,
   * so without this the zoomed photo shows no accessory colour at all.
   *
   * Rather than re-deriving pixel data for the lightbox's copy of the
   * photo, this reuses the already-rendered overlay PNGs from `overlays`
   * (same data URL, just attached to a second <img>). The clone is
   * appended as a sibling of .pswp__img inside .pswp__zoom-wrap, which is
   * the element PhotoSwipe actually pans/zooms via CSS transform — being a
   * sibling under that same transformed parent, the clone pans/zooms in
   * lockstep with the photo for free, no transform math of our own needed.
   * A MutationObserver keeps its width/height matched to .pswp__img (see
   * syncLightboxOverlaySize) — PhotoSwipe both resizes it on every zoom
   * level change and replaces it outright once it swaps a low-res
   * placeholder for the real image, so sizing is re-read fresh from
   * whatever .pswp__img currently is rather than tracked off one reference.
   * ------------------------------------------------------------------- */

  var lightboxOverlays = {};

  function syncLightboxOverlaySize(wrap) {
    var img = wrap.querySelector('.pswp__img');
    if (!img) return;
    Object.keys(lightboxOverlays).forEach(function (target) {
      lightboxOverlays[target].style.width = img.style.width;
      lightboxOverlays[target].style.height = img.style.height;
    });
  }

  function attachLightboxOverlays(pswpImg) {
    var wrap = pswpImg.parentElement;
    if (!wrap || wrap.querySelector('.wj-overlay')) return;

    Object.keys(overlays).forEach(function (target) {
      var source = overlays[target];
      var el = document.createElement('div');
      el.className = source.className;
      el.style.position = 'absolute';
      el.style.top = '0';
      el.style.left = '0';
      el.style.backgroundImage = source.style.backgroundImage;
      wrap.appendChild(el);
      lightboxOverlays[target] = el;
    });

    syncLightboxOverlaySize(wrap);

    // PhotoSwipe loads a low-res placeholder first, then swaps in a
    // higher-resolution <img> once it's ready (a different DOM node, not
    // just a style change on the same one) and resizes it again on every
    // zoom level change. Watching the wrap's subtree for style changes and
    // node swaps catches both in one place, rather than binding to a
    // single <img> reference that may already be stale by the time it's
    // read (a ResizeObserver on the placeholder node missed the later
    // resize entirely once PhotoSwipe replaced it with the real image).
    var wrapObserver = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return m.target === wrap || (m.target.classList && m.target.classList.contains('pswp__img'));
      });
      if (relevant) syncLightboxOverlaySize(wrap);
    });
    wrapObserver.observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  function watchForLightboxImage(pswpEl) {
    var existingImg = pswpEl.querySelector('.pswp__img');
    if (existingImg) {
      attachLightboxOverlays(existingImg);
      return;
    }

    var innerObserver = new MutationObserver(function () {
      var img = pswpEl.querySelector('.pswp__img');
      if (img) {
        attachLightboxOverlays(img);
        innerObserver.disconnect();
      }
    });
    innerObserver.observe(pswpEl, { childList: true, subtree: true });
  }

  function watchForLightbox() {
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('pswp')) {
            watchForLightboxImage(node);
          }
        });

        mutation.removedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('pswp')) {
            lightboxOverlays = {};
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true });
  }

  function initOverlays() {
    root.querySelectorAll('[data-addon]').forEach(function (addonEl) {
      var target = addonEl.getAttribute('data-overlay-target');
      if (!target) return;

      var toggle = addonEl.querySelector('.checkbox-control input');
      var swatches = addonEl.querySelectorAll('input[type="radio"]');

      function currentColor() {
        var checked = addonEl.querySelector('input[type="radio"]:checked');
        var wrap = checked ? checked.closest('[data-color]') : addonEl.querySelector('[data-color]');
        return wrap ? wrap.getAttribute('data-color') : null;
      }

      setOverlayColor(target, currentColor());

      if (toggle) {
        toggle.addEventListener('change', function () {
          showOverlay(target, toggle.checked);
          updateDisplayedPrice();
        });
      }

      swatches.forEach(function (radio) {
        radio.addEventListener('change', function () {
          var wrap = radio.closest('[data-color]');
          if (wrap) setOverlayColor(target, wrap.getAttribute('data-color'));
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
   * Live price update
   *
   * The price shown next to the title is Shopify's own <sale-price>
   * element, driven purely by the notebook insert variant — it has no
   * concept of the Elastic Band / Pen Loop, since those are separate
   * products stacked on top rather than options of this one, so checking
   * an add-on otherwise left the displayed price wrong (still $38 with
   * $1-2 of add-ons actually in the cart). This adds the checked add-ons'
   * prices on top of whatever <sale-price> currently shows.
   *
   * A MutationObserver (rather than hooking whatever event the theme uses
   * internally to re-render <sale-price> on variant change) watches the
   * element directly and reapplies the add-on total whenever its content
   * changes for any reason — e.g. switching the notebook insert variant —
   * so this doesn't depend on knowing that mechanism, just its outcome.
   *
   * updateDisplayedPrice disconnects priceObserver before writing and
   * reconnects after, rather than guarding with a boolean flag: a flag
   * reset synchronously right after the write is already back to false by
   * the time the observer's callback actually runs (MutationObserver
   * callbacks fire as a microtask, after the current synchronous code has
   * finished), so the callback saw "not currently updating" and called
   * updateDisplayedPrice again — on every call, even when nothing needed
   * to change, which queued another mutation and called it again forever.
   * That infinite loop froze the tab on the very first toggle click.
   * Disconnecting for the duration of the write means our own mutation is
   * never queued in the first place, no flag or timing assumption needed.
   * ------------------------------------------------------------------- */

  var priceObserver = null;

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', amount);
  }

  function getAddonTotalCents() {
    var total = 0;
    root.querySelectorAll('[data-addon]').forEach(function (addonEl) {
      var toggle = addonEl.querySelector('.checkbox-control input');
      if (toggle && toggle.checked) {
        total += parseInt(addonEl.getAttribute('data-price'), 10) || 0;
      }
    });
    return total;
  }

  function getPriceElement() {
    return document.querySelector('price-list.price-list--product sale-price');
  }

  function updateDisplayedPrice() {
    var salePrice = getPriceElement();
    if (!salePrice) return;

    var baseCents = parseInt(root.getAttribute('data-base-price'), 10) || 0;
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var totalText = formatMoney(baseCents + getAddonTotalCents(), moneyFormat);

    // Shopify's own <sale-price> custom element inserts an extra leading
    // text node ahead of the sr-only label on top of the trailing price
    // text the Liquid template renders (observed directly in the DOM, not
    // documented) — targeting the FIRST text node silently updated that
    // throwaway leading node instead, leaving the real displayed price
    // untouched and duplicating text into the accessible name. The last
    // text node is reliably the one actually rendered on screen.
    var textNodes = Array.prototype.filter.call(salePrice.childNodes, function (node) {
      return node.nodeType === 3;
    });
    var textNode = textNodes[textNodes.length - 1];

    if (priceObserver) priceObserver.disconnect();
    if (textNode) {
      textNode.textContent = totalText;
    } else {
      salePrice.appendChild(document.createTextNode(totalText));
    }
    if (priceObserver) priceObserver.observe(salePrice, { childList: true, characterData: true, subtree: true });
  }

  function watchNativePriceUpdates() {
    var salePrice = getPriceElement();
    if (!salePrice) return;

    priceObserver = new MutationObserver(function () {
      updateDisplayedPrice();
    });
    priceObserver.observe(salePrice, { childList: true, characterData: true, subtree: true });
  }

  /* ----------------------------------------------------------------------
   * Toggle -> reveal colour picker (existing behaviour)
   * ------------------------------------------------------------------- */

  root.querySelectorAll('[data-addon]').forEach(function (addonEl) {
    var toggle = addonEl.querySelector('.checkbox-control input');
    var colorWrap = addonEl.querySelector('.wool-journal-addon__colors');
    if (toggle && colorWrap) {
      toggle.addEventListener('change', function () {
        colorWrap.hidden = !toggle.checked;
      });
    }
  });

  /* ----------------------------------------------------------------------
   * Back-forward cache restore
   *
   * Navigating back to this page (browser back/forward) can restore it
   * from bfcache: the DOM reappears instantly with whatever toggle/swatch
   * state it had when the customer left, but that's no guarantee the
   * colour classification had actually finished by then — a toggle
   * checked/swatch picked right before navigating away can restore into a
   * page whose overlay never got its first backgroundImage painted. Since
   * bfcache preserves the JS heap too, `overlays`/`regionInfo` are still
   * whatever they were, so re-driving each addon's current DOM state
   * through the same setOverlayColor/showOverlay path used on ordinary
   * toggle clicks is enough to catch it back up — no re-init needed.
   * ------------------------------------------------------------------- */

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    root.querySelectorAll('[data-addon]').forEach(function (addonEl) {
      var target = addonEl.getAttribute('data-overlay-target');
      if (!target) return;

      var toggle = addonEl.querySelector('.checkbox-control input');
      var checked = addonEl.querySelector('input[type="radio"]:checked');
      var wrap = checked ? checked.closest('[data-color]') : addonEl.querySelector('[data-color]');
      var hex = wrap ? wrap.getAttribute('data-color') : null;

      if (hex) setOverlayColor(target, hex);
      if (toggle) showOverlay(target, toggle.checked);
    });

    updateDisplayedPrice();
  });

  initOverlays();
  watchForLightbox();
  updateDisplayedPrice();
  watchNativePriceUpdates();
  hookAfterCartAdd();
  hookCart();
}());
